module.exports = __webpack_public_path__ + "img/单独清洗.15e84f36.svg";